module.exports = __webpack_public_path__ + "static/media/camera-white-small.c64041d0.svg";